import {FetchBaseQueryError} from "@reduxjs/toolkit/query";

import {kmApiLink} from "@pg-mono/km-routes";

import {kmApi} from "../../km_app/api/km_api";
import {GetHomeMatchPreleadListDto} from "../types/GetHomeMatchPreleadListDto";
import {RetryHomeMatchPreleadListError} from "../types/RetryHomeMatchPreleadListError";
import {
    IGetHomeMatchPreleadListParams,
    mergeHomeMatchPreleadList,
    serializeHomeMatchPreleadListQueryArgs,
    shouldReplaceHomeMatchPreleadList
} from "../utils/merge_home_match_prelead_list";

export const getHomeMatchPreleadListApi = kmApi.injectEndpoints({
    endpoints: (builder) => ({
        getHomeMatchPreleadList: builder.query<GetHomeMatchPreleadListDto, IGetHomeMatchPreleadListParams | void>({
            queryFn: async (params, _api, _extraOptions, fetchBaseQuery) => {
                const queryArgs = {
                    url: kmApiLink.homematch.prelead.list(),
                    params: params && params.status !== undefined ? {status: params.status} : undefined
                };

                const result = await fetchBaseQuery(queryArgs);

                if (result.error && result.error.status === 503) {
                    const retryAfter = result.meta?.response?.headers?.get("Retry-After");

                    if (retryAfter) {
                        return {
                            error: {
                                status: "CUSTOM_ERROR",
                                data: {retryAfter}
                            }
                        } as RetryHomeMatchPreleadListError;
                    }
                }

                return result as {data: GetHomeMatchPreleadListDto} | {error: FetchBaseQueryError};
            },
            serializeQueryArgs: ({queryArgs}) => serializeHomeMatchPreleadListQueryArgs(queryArgs),
            merge: (currentCache, newItems, {arg}) => mergeHomeMatchPreleadList(currentCache, newItems, arg),
            forceRefetch: ({currentArg}) => shouldReplaceHomeMatchPreleadList(currentArg),
            providesTags: ["PreleadList"]
        }),
        getHomeMatchPendingAcceptedPreleadList: builder.query<GetHomeMatchPreleadListDto, void>({
            query: () => ({
                url: kmApiLink.homematch.prelead.list(),
                params: {state: "pending_accepted"}
            }),
            providesTags: ["PendingAcceptedPreleadList"]
        })
    })
});

export const {useGetHomeMatchPreleadListQuery, useLazyGetHomeMatchPreleadListQuery, useGetHomeMatchPendingAcceptedPreleadListQuery} =
    getHomeMatchPreleadListApi;
import {FetchBaseQueryError} from "@reduxjs/toolkit/query";

import {kmApiLink} from "@pg-mono/km-routes";

import {kmApi} from "../../km_app/api/km_api";
import {GetHomeMatchPreleadListDto} from "../types/GetHomeMatchPreleadListDto";
import {RetryHomeMatchPreleadListError} from "../types/RetryHomeMatchPreleadListError";
import {
    IGetHomeMatchPreleadListParams,
    mergeHomeMatchPreleadList,
    serializeHomeMatchPreleadListQueryArgs,
    shouldReplaceHomeMatchPreleadList
} from "../utils/merge_home_match_prelead_list";

export const getHomeMatchPreleadListApi = kmApi.injectEndpoints({
    endpoints: (builder) => ({
        getHomeMatchPreleadList: builder.query<GetHomeMatchPreleadListDto, IGetHomeMatchPreleadListParams | void>({
            queryFn: async (params, _api, _extraOptions, fetchBaseQuery) => {
                const queryArgs = {
                    url: kmApiLink.homematch.prelead.list(),
                    params: params && params.status !== undefined ? {status: params.status} : undefined
                };

                const result = await fetchBaseQuery(queryArgs);

                if (result.error && result.error.status === 503) {
                    const retryAfter = result.meta?.response?.headers?.get("Retry-After");

                    if (retryAfter) {
                        return {
                            error: {
                                status: "CUSTOM_ERROR",
                                data: {retryAfter}
                            }
                        } as RetryHomeMatchPreleadListError;
                    }
                }

                return result as {data: GetHomeMatchPreleadListDto} | {error: FetchBaseQueryError};
            },
            serializeQueryArgs: ({queryArgs}) => serializeHomeMatchPreleadListQueryArgs(queryArgs),
            merge: (currentCache, newItems, {arg}) => mergeHomeMatchPreleadList(currentCache, newItems, arg),
            forceRefetch: ({currentArg}) => shouldReplaceHomeMatchPreleadList(currentArg),
            providesTags: ["PreleadList"]
        }),
        getHomeMatchPendingAcceptedPreleadList: builder.query<GetHomeMatchPreleadListDto, void>({
            query: () => ({
                url: kmApiLink.homematch.prelead.list(),
                params: {state: "pending_accepted"}
            }),
            providesTags: ["PendingAcceptedPreleadList"]
        })
    })
});

export const {useGetHomeMatchPreleadListQuery, useLazyGetHomeMatchPreleadListQuery, useGetHomeMatchPendingAcceptedPreleadListQuery} =
    getHomeMatchPreleadListApi;
